module.exports = __webpack_public_path__ + "static/media/banner_home_lg.3bd78482.png";